<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="IsLoading() == true || DriversImported == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">
			Add Driver
		</button>
		<button [disabled]="IsLoading() == true || DriversImported == true" class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">
			Edit Driver
		</button>
		<button [disabled]="IsLoading() == true || DriversImported == true" class="btn btn-primary" style="margin-left: 5px" (click)="onToggle()">
			Toggle Driver
		</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onImport()">Import Drivers</button>
		<button [disabled]="IsLoading() == true" *ngIf="IsSU() == true" class="btn btn-danger" style="margin-left: 5px" (click)="onDelete()">
			Delete Driver (SU Only)
		</button>
		<button [disabled]="IsLoading() == true" *ngIf="IsSU() == true" class="btn btn-danger" style="margin-left: 5px" (click)="onDeleteInactive()">
			Delete Inactive Drivers (SU Only)
		</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstDriverVerifyAuth"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedDriverVerifyAuth"
		dataKey="DriverVerifyAuthID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--LicenseNbr-->
				<th>
					<p-columnFilter type="text" field="LicenseNbr" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--DriverName-->
				<th>
					<p-columnFilter type="text" field="DriverName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th class="ButtonCol"></th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="LicenseNbr">License Number<p-sortIcon field="LicenseNbr"></p-sortIcon></th>
				<th pSortableColumn="DriverName">Name<p-sortIcon field="DriverName"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>

				<th class="ButtonCol" pSortableColumn="OverrideCount">Delete Override Attempts<p-sortIcon field="OverrideCount"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-DriverVerifyAuth>
			<tr [pSelectableRow]="DriverVerifyAuth" (dblclick)="onRowDblClick(DriverVerifyAuth)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ DriverVerifyAuth[col.field] }}
				</td>

				<td style="font-weight: bold" [style.color]="DriverVerifyAuth.Active == 1 ? 'Black' : 'Red'">
					{{ DriverVerifyAuth["ActiveDesc"] }}
				</td>

				<td class="ButtonCol">
					<button [disabled]="IsLoading() == true" class="btn btn-danger" (click)="onClear(DriverVerifyAuth.DriverVerifyAuthID)">
						Clear ({{ DriverVerifyAuth.OverrideCount }})
					</button>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
